import { useDefaultContext } from './useDefaultContext'

export const useCart = () => {
  const defaultContext = useDefaultContext()

  return defaultContext.cart
}
